/**
 * **지금 화면에 있는가.**
 *
 * 이 ERP 는 화면을 탭으로 살려 둔다. 다른 화면으로 옮겨도 앞 화면의 DOM 이 그대로
 * 남아 있어서, `document.querySelectorAll` 로 찾으면 **남의 화면 것**이 걸린다.
 * 닫힌 모달도 마찬가지다.
 *
 * 2026-09-01 하루에 이 뿌리로 셋이 났다.
 *
 * | 어디 | 무슨 일 |
 * |---|---|
 * | 첨부 상자 | 안 보이는 상자를 잡아 다른 문서에 붙을 뻔했다 |
 * | 콤보 선택지 | `spjangcd` 와 `bankcd` 가 둘 다 `여 \| 부 \| 남 \| 양력` 을 돌려줬다 |
 * | 탭 관찰 | 탭 수가 화면마다 누적됐다 — `2 → 4 → 6 → … → 125개` |
 *
 * 신호가 없어서가 아니다. **매번 안 물어서**다 — `document.querySelectorAll` 이 가장
 * 짧은 길이고 범위 좁히기는 선택이었다. 그래서 잣대를 여기 하나로 모은다.
 * 새 조회를 짤 때 손이 닿는 곳에 있어야 다시 안 배운다.
 *
 * 잣대는 **자리를 차지하는가**다. 감춰진 화면(`display:none`)은 상자도 안 만들고 크기도
 * 0 이다. 화면 밖으로 스크롤된 칸은 크기가 남아 있으므로 이 잣대로 걸리지 않는다 —
 * 그것이 맞다.
 *
 * 두 가지를 다 본다. 실제 브라우저에서는 둘이 같은 말을 하지만, jsdom 은 크기를
 * 흉내내지 않아서 **시험마다 흉내내는 쪽이 다르다** — 어느 한쪽만 보면 멀쩡한 시험이
 * 빨개진다(합치다가 실제로 겪었다).
 */
export function onScreen(element: Element | null | undefined): element is HTMLElement {
  if (!element || !element.isConnected) return false;
  const node = element as HTMLElement;
  if (node.getClientRects().length > 0) return true;
  const box = node.getBoundingClientRect();
  return box.width > 0 || box.height > 0;
}

/**
 * **지금 화면에 있는 것만** 찾는다. 「이 화면의 무엇」을 찾을 때는 언제나 이것을 쓴다.
 *
 * 하나도 안 보이면 빈 배열이다. 그때 전역으로 넓히는 것은 **부르는 쪽이 정한다** —
 * 고르는 자리는 넓혀야 하고(못 찾으면 그 걸음이 죽는다), 사람에게 내미는 자리는
 * 넓히면 안 된다(남의 칸 선택지를 내밀게 된다).
 */
export function onScreenAll<T extends HTMLElement = HTMLElement>(
  selector: string,
  root: ParentNode = document,
): T[] {
  return Array.from(root.querySelectorAll<T>(selector)).filter(onScreen);
}
